import packageJson from '../../package.json';

/**
 * Versão do sistema — fonte ÚNICA (package.json), no padrão do Glivo Pro/Social.
 * Exibida na sidebar (subtítulo da marca), na tela de login e no modo TV.
 * Para publicar uma nova versão: `npm version patch|minor|major` no frontend.
 */
export const APP_VERSION = (packageJson as { version?: string }).version ?? '1.0.0';
